import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/I18nConfig';
import { initializeIcons } from "@fluentui/font-icons-mdl2";

initializeIcons();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);